import * as d3 from 'd3'

export default {
  methods: {

    draw_Forms() {

      this.canvasForms = this.svg
      .append('g')
      .attr('transform', `translate(0, 0)`)
      .attr('font-family', 'roboto')
      .attr('cursor', 'default')

      
      this.func_TableGrid_Group(
        JSON.parse(JSON.stringify(this.Queries.SQL1))
      ) // =====> func_GroupTable.js
      

      this.draw_ChartCanvas() // -----> draw_ChartCanvas.js
      this.draw_Timeline() // -----> draw_Timeline.js
      this.chart_Router() //-----> chart_Router.js
    },

  }
}
           